import {getInventory} from "../../api/Api";
import {useEffect, useState} from 'react';
import {Row, Col, Card, Input, Divider, Checkbox} from "antd";
import {CategoryType, UnitType} from "../../api/Constants";
import {fixedToDisplayUnit} from "../../util/unitutils";

export const InventoryTable = ({onApiFail, refresh, disableLinks=true, props}) => {
    const [inventoryMap, setInventoryMap] = useState({});

    const [searchVal, setSearchVal] = useState(undefined);
    const [wholesaleChecked, setWholesaleChecked] = useState(true);
    const [packagedChecked, setPackagedChecked] = useState(true);

    useEffect(() => {
        getInventory().then((x) => {
            let tableData = x.map((val, index) => {
                return {...val, key: index}
            });
            tableData = tableData.filter(line => ((line.category === CategoryType.Wholesale) || (line.category === CategoryType.Packaged)) && (line.quantity > 0));
            const nextMap = {};
            tableData.forEach(line => {
                // hash by product
                const {itemId: productId} = line;
                if (nextMap[productId] === undefined) {
                    nextMap[productId] = {
                        ...line
                    };
                } else {
                    // just add the quantity
                    nextMap[productId].quantity += line.quantity;
                }
            });
            // console.log(tableData);
            // console.log(`total ${Object.values(nextMap).length} products`);
            setInventoryMap(nextMap);
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [onApiFail]);

    const onSearchChange = (e) => {
        setSearchVal (e.target.value);
    }

    const onWholesaleCheck = (e) => {
        setWholesaleChecked(e.target.checked)
        // if we are setting wholesale to false, set packaged to true
        if (e.target.checked === false) {
            setPackagedChecked(true);
        }
    }

    const onPackagedCheck = (e) => {
        setPackagedChecked(e.target.checked);
        // if we are setting packaged to false, set wholesale to true
        if (e.target.checked === false) {
            setWholesaleChecked(true);
        }
    }


    let preSearch = Object.values(inventoryMap);
    let postSearch = preSearch;
    if (wholesaleChecked === false) {
        // wholesale is false so filter only the packaged
        postSearch = postSearch.filter(line => line.category === CategoryType.Packaged);
    } else if (packagedChecked === false) {
        // packaged is false so search for wholesale
        postSearch = postSearch.filter(line => line.category === CategoryType.Wholesale);
    }
    if (searchVal !== undefined && searchVal.length >= 3) {
        postSearch = postSearch.filter(line => {
            const name = line.name.toLowerCase();
            return name.includes(searchVal.toLowerCase());
        });
    }
    const productsFlat = postSearch;

    // creat an array with groups of 3 for the layout
    const productsBy3 = [];
    let productLine = [];
    let window = 0;
    for (let i=0; i<productsFlat.length; i++) {
        productLine.push(productsFlat[i]);
        window ++;
        if ((window === 3) || (i === productsFlat.length-1)) {
            productsBy3.push(productLine);
            productLine = [];
            window = 0;
        }
    }

    return <div>
        <div>
        <Card style={{textAlign: 'left'}} title={<b>Search</b>}>
            <Input onChange={onSearchChange} value={searchVal} placeholder={'What are you looking for?'} />
            <Divider />
            <Row>
                <Col span={2}>
                    <b>Wholesale:</b>
                </Col>
                <Col>
                    <Checkbox checked={wholesaleChecked} onChange={onWholesaleCheck}/>
                </Col>
            </Row>
            <Row>
                <Col span={2}>
                    <b>Packaged:</b>
                </Col>
                <Col>
                    <Checkbox checked={packagedChecked} onChange={onPackagedCheck}/>
                </Col>
            </Row>

        </Card>
        </div>
        <Divider/>
        <div>
        {productsBy3.map((row, index) => {
            return <Row key={index}>
                {row.map((item, cIndex) => {
                    const itemQuantity = fixedToDisplayUnit(item.quantity, item.unit)
                    return <Col span={8} key={cIndex}>
                        <Card variant={'borderless'} style={{margin: 8}}
                            cover={(item.imageUri !== null) ?
                                <img src={item.imageUri} alt={'product'} /> : undefined
                            }
                        >
                            <Row>
                                {item.name}
                            </Row>
                            <Row>
                                {CategoryType.Label[item.category]}
                            </Row>
                            <Row>
                                {`${itemQuantity} ${UnitType.Label[item.unit]}`}
                            </Row>
                        </Card>
                    </Col>
                })}
            </Row>
        })}
        </div>
    </div>
}